import styles from "./Hero.module.less";

export const HeroBadges = ({ children }) => {
  return <div className={styles.HeroBadges}>{children}</div>;
};
